import { IconUsersPlus as TablerIconUsersPlus } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconUsersPlus = /*#__PURE__*/ createOutlineIcon(TablerIconUsersPlus, 'IconUsersPlus');
